import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LoadingOutlined } from '@ant-design/icons'

import { ListHistoryLogModalWrapper } from './ListHistoryLogModalStyled'
import { inject, observer } from 'mobx-react'
import common_history_log from '../../enum_utils'
import date_format from '../../date_format'
import DiffTableBoardReport from './DiffTable/DiffTableBoardReport'

const ListHistoryBoardReportModal = props => {
  const {
    type,
    taskInfo,
    isVisible,
    handleCloseHistory,
    listHistoryLogStore,
    fileMap,
  } = props

  const { list, isLoading, message } = listHistoryLogStore

  useEffect(() => {
    if (!taskInfo.code) {
      return
    }

    const fetchHistory = async () => {
      try {
        await listHistoryLogStore.getList(taskInfo.code)
      } catch (error) {
        console.error('Error loading history:', error)
      }
    }

    fetchHistory()

    return () => {
      listHistoryLogStore.clear()
    }
  }, [taskInfo.code, listHistoryLogStore])

  // Safely filter the list - ensure it's an array
  const filteredList = Array.isArray(list)
    ? list.filter(item => {
        try {
          // data_before and data_after are already JSON strings, not objects
          const before = item.data_before || '{}'
          const after = item.data_after || '{}'
          return before !== after
        } catch (error) {
          console.error('Error filtering item:', error, item)
          return false
        }
      })
    : []

  return (
    <ListHistoryLogModalWrapper
      title={'Lịch sử'}
      width={1300}
      style={{ top: 40 }}
      visible={isVisible}
      closable={true}
      maskClosable={true}
      onCancel={handleCloseHistory}
      footer={null}
      wrapClassName="custom-modal-wrapper">
      <div>
        {isLoading && (
          <LoadingOutlined style={{ marginLeft: 10 }} spin={true} />
        )}

        {message && <p>{message}</p>}

        {!isLoading && filteredList.length > 0 && (
          <ul>
            {filteredList.map(item => (
              <li key={item.id} style={{ marginBottom: 16 }}>
                <span style={{ marginBottom: 8, display: 'block' }}>
                  <b>{common_history_log.enumToText(item.action)}</b> lúc
                  <span>
                    {' '}
                    {date_format.HH_mm_DD_MM_YYYY(item.processed_date)}
                  </span>{' '}
                  bởi
                  <b> {item.user.name_uppercase}</b>
                </span>
                <DiffTableBoardReport
                  key={item.id}
                  dataBefore={
                    item.action === 'CREATE' ? '{}' : item.data_before
                  }
                  dataAfter={item.action === 'CREATE' ? '{}' : item.data_after}
                  type={type}
                  fileMap={fileMap}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </ListHistoryLogModalWrapper>
  )
}

ListHistoryBoardReportModal.propTypes = {
  type: PropTypes.string,
  isVisible: PropTypes.bool,
  handleCloseHistory: PropTypes.func,
  taskInfo: PropTypes.any,
}

export default inject('listHistoryLogStore')(
  observer(ListHistoryBoardReportModal)
)
